import React from "react";

const CheckoutRouter = () => {
  return (
    <div className="p-2">
      <span>
        Home › ShoppingCart › Checkout Process 
        Series
      </span>
    </div>
  );
};

export default CheckoutRouter;
